
import Vue from "vue";
import box from "@/components/BoxCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import OrderRequestBill from "@/assets/js/Bill/OrderRequestBill";
import Utils from "@/assets/js/Utils";
import action from "@/components/ActionBarCom.vue";
import pageCom from "@/components/PageCom.vue";
export default Vue.extend({
  components: { box, action, pageCom },
  data() {
    return {
      type: 0,
      lights: [] as any[],
      orders: [] as any,
      lightPage: {
        items: [] as any[],
        total: 0 as number,
        pageSize: Utils.getDefalutPageSize(),
        currentPage: 1,
        searchStr: null as any,
      },
      orderPage: {
        items: [] as any[],
        total: 0 as number,
        pageSize: Utils.getDefalutPageSize(),
        currentPage: 1,
        searchStr: null as any,
      },
    };
  },
  async mounted() {
    await this.getLightItems();
  },
  methods: {
    lightPageChange(val: number, size: number) {
      this.lightPage.currentPage = val;
      this.lightPage.pageSize = size;
      this.getLightItems();
    },
    lightSearch() {
      this.getLightItems();
    },
    async lightCheck() {
      await HttpUtil.XCHttpPost(Urls.CheckOrder, "", true, false);
      this.lightPage.currentPage = 0;
      this.lightPage.total = 0;
      await this.getLightItems();
    },
    async orderCheck() {
      await HttpUtil.XCHttpPost(Urls.CheckOrder, "", true, false);
      this.orderPage.currentPage = 0;
      this.lightPage.total = 0;
      await this.getOrderItems();
    },
    async change(val: any) {
      if (val == 0) {
        this.lightPage.currentPage = 0;
        this.lightPage.total = 0;
        await this.getLightItems();
      } else {
        this.orderPage.currentPage = 0;
        this.lightPage.total = 0;
        await this.getOrderItems();
      }
    },
    async getOrderItems() {
      const ret: any = await OrderRequestBill.GetOrderInspections(
        this.orderPage.searchStr,
        this.orderPage.currentPage,
        this.orderPage.pageSize
      );
      this.orders = ret.data;
      this.orderPage.total = ret.total;
    },
    async getLightItems() {
      const ret: any = await OrderRequestBill.GetLightInspections(
        this.lightPage.searchStr,
        this.lightPage.currentPage,
        this.lightPage.pageSize
      );
      this.lights = ret.data;
      this.lightPage.total = ret.total;
    },
  },
});
